export default {
  state: {
    name: '张飞',
  },
  mutations: {
    updateName(state) {
      state.name = '关羽';
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/moduleA.js